import { render, staticRenderFns } from "./FournisseursItemEval.vue?vue&type=template&id=5048b5e2&"
import script from "./FournisseursItemEval.vue?vue&type=script&lang=js&"
export * from "./FournisseursItemEval.vue?vue&type=script&lang=js&"
import style0 from "./FournisseursItemEval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports